module.exports = __webpack_public_path__ + "img/heart-rounded.6956781f.svg";